<template>
  <div>
    <base-header class="pb-6 pb-8 pt-5 pt-md-8" type="gradient-success">
      <!-- Card stats -->
      <CardStats></CardStats>
    </base-header>

    <CardList></CardList>

  </div>
</template>
<script>
  // Charts
  import CardStats from "../components/CardStats";
  // Tables
  // Lists
  import CardList from "../components/Lists/CardList";

  import { mapState } from "vuex";

  export default {
    components: {
      CardList,
      CardStats
    },
    computed: {
      ...mapState({
        user: state => state.user,
      })
    },
    data() {
      return {
        color: '#46ca9b',
        loading: false,
      };
    },
    methods: {},
  };
</script>
